// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2vPpV","box":"WorkspacesBox_box__3eCBS","node":"WorkspacesBox_node__3S1ea"};